import React from "react";
import PropTypes from "prop-types";
import ViewGreen from "rialto-icons/ViewGreen";

import Translate from "utils/translate";

import styles from "./SeeMore.css";

const { t } = new Translate("SeeMore");

const SeeMore = ({ onClick, text }) => (
  <div className={styles.root} onClick={onClick}>
    <ViewGreen />
    {text}
  </div>
);

SeeMore.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
};

SeeMore.defaultProps = {
  text: t("seeMore"),
};

export default SeeMore;
